var URL_REGEX = /^https?:\/\/(?:[-a-zA-Z0-9]{1,256}\.){1,10}[a-z]{2,24}(?::\d{1,5})?\b(?!@)(?:(?:(?:\/|\?\S))[-a-zA-Z0-9@:%_;+.~#?&/=()[\]*,!]*)?/;
var IP_URL_REGEX = /^https?:\/\/(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)[-a-zA-Z0-9@:%_;+.~#?&/=()[\]*,!]*/;
var NO_SPACE_REGEX = /^\S*$/;
export var isValidUrl = function isValidUrl(url) {
  return NO_SPACE_REGEX.test(url) && (URL_REGEX.test(url) || IP_URL_REGEX.test(url));
};